<div class="sh-dashboard-panel">
    <nav class="sh-dashboard-panel__navigation">
        <h3 *ngIf="title" class="sh-page-title--small-subsection sh-dashboard-panel__navigation__title">{{ title }}</h3>

        <ul class="sh-dashboard-navigation__list">
            <li class="sh-dashboard-navigation__list__item" *ngFor="let link of navigationLinks">
                <sh-icon-link [item]="link" class="sh-dashboard-navigation__list__link"></sh-icon-link>
            </li>
        </ul>
    </nav>
</div>
